module.exports = __webpack_public_path__ + "static/media/vintage05.a80a7c37.png";